import * as ApiRequests from '../../api/requests';
import { AuthHelper } from '../../types/auth-helper-types';
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const getTemperatureGraphProperties = async (authHelper: AuthHelper, deviceId: string) => {
    const temperatureResult = await ApiRequests.getTemperatureGraphData({ deviceId: deviceId }, { authHelper });

    if (!temperatureResult.ok) {
        console.error(ApiRequests.extractErrorCodeWithMessage(temperatureResult.response));
        throw new Error(ApiRequests.extractErrorCodeWithMessage(temperatureResult.response));
    }

    return temperatureResult.response.data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const getHumidityGraphProperties = async (authHelper: AuthHelper, deviceId: string) => {
    const humidityResult = await ApiRequests.getHumidityGraphData({ deviceId: deviceId }, { authHelper });

    if (!humidityResult.ok) {
        console.error(ApiRequests.extractErrorCodeWithMessage(humidityResult.response));
        throw new Error(ApiRequests.extractErrorCodeWithMessage(humidityResult.response));
    }

    return humidityResult.response.data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const getLoadGraphProperities = async (authHelper: AuthHelper, deviceId: string) => {
    const LoadGraphResult = await ApiRequests.getLoadGraphData({ deviceId: deviceId }, { authHelper });

    if (!LoadGraphResult.ok) {
        console.error(ApiRequests.extractErrorCodeWithMessage(LoadGraphResult.response));
        throw new Error(ApiRequests.extractErrorCodeWithMessage(LoadGraphResult.response));
    }

    return LoadGraphResult.response.data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const getSensorListResponse = async (authHelper: AuthHelper, deviceId: string) => {
    const sensorResult = await ApiRequests.getSensorListData(
        {
            deviceId: deviceId,
        },
        { authHelper }
    );
    if (!sensorResult.ok) {
        console.error(ApiRequests.extractResponseNotOkMessage(sensorResult.response));
        throw new Error(ApiRequests.extractErrorCodeWithMessage(sensorResult.response));
    }
    return sensorResult.response.data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const getDatetimeListResponse = async (authHelper: AuthHelper, deviceId: string) => {
    const DatetimeResult = await ApiRequests.getDatetimeListData(
        {
            deviceId: deviceId,
        },
        { authHelper }
    );
    if (!DatetimeResult.ok) {
        console.error(ApiRequests.extractResponseNotOkMessage(DatetimeResult.response));
        throw new Error(ApiRequests.extractErrorCodeWithMessage(DatetimeResult.response));
    }
    return DatetimeResult.response.data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const getPDIGraphResponse = async (authHelper: AuthHelper, deviceId: string, channelNumber: any, startDate: string, endDate: string) => {
   
    const filterChannelList: any = [];
    channelNumber.forEach((element: any) => {
            const obj = {
                channelNumber: element,
            };
            filterChannelList.push(obj);
        });

    const pdiGraphResult = await ApiRequests.getPDIGraphData(
        {
            deviceId: deviceId,
            channels: filterChannelList,
            startDate: startDate,
            endDate: endDate         
          
        },
        {
            authHelper,
        }
    );
  

    if (!pdiGraphResult.ok) {
        console.error(ApiRequests.extractResponseNotOkMessage(pdiGraphResult.response));
        throw new Error(ApiRequests.extractErrorCodeWithMessage(pdiGraphResult.response));
    }    
    return pdiGraphResult.response.data;
};
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const getQmaxApiResponse = async (authHelper: AuthHelper, deviceId: string, channelNumber: any,startDate: string, endDate: string) => {
    
    const filterChannelList: any = [];
    channelNumber        
        .forEach((element: any) => {
            const obj = {
                channelNumber: element,
            };
            filterChannelList.push(obj);
        });
        
    
    const maxQmaxResponseData = await ApiRequests.getQMAXGraphData(
        {
            deviceId: deviceId,
            channels: filterChannelList,
            startDate: startDate,
            endDate: endDate   
        },
        {
            authHelper,
        }
    );


    if (!maxQmaxResponseData.ok) {
        console.error(ApiRequests.extractResponseNotOkMessage(maxQmaxResponseData.response));
        throw new Error(ApiRequests.extractErrorCodeWithMessage(maxQmaxResponseData.response));
    }
    return maxQmaxResponseData.response.data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const getPPCApiResponse = async (authHelper: AuthHelper, deviceId: string, channelNumber: any, startDate: string, endDate: string) => {
    
    const filterChannelList: any = [];
    channelNumber.forEach((element: any) => {
            const obj = {
                channelNumber: element,
            };
            filterChannelList.push(obj);
        });

    const ppcResponseData = await ApiRequests.getPPCGraphData(
        {
            deviceId: deviceId,
            channels: filterChannelList,
            startDate: startDate,
            endDate: endDate  
        },
        {
            authHelper,
        }
    );
  
    if (!ppcResponseData.ok) {
        console.error(ApiRequests.extractResponseNotOkMessage(ppcResponseData.response));
        throw new Error(ApiRequests.extractErrorCodeWithMessage(ppcResponseData.response));
    }
    return ppcResponseData.response.data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const getRelativeConditionIndexApiResponse = async (authHelper: AuthHelper, deviceId: string,startMonthAndYear?: string, endMonthAndYear?: string) => {
    const responseConditionIndex = await ApiRequests.getRelativeConditionIndex(
        {
            deviceId: deviceId,
            startMonthAndYear: startMonthAndYear,
            endMonthAndYear: endMonthAndYear
        },
        {
            authHelper
        }
    );
  
    if (!responseConditionIndex.ok) {
        console.error(ApiRequests.extractResponseNotOkMessage(responseConditionIndex.response));
        throw new Error(ApiRequests.extractErrorCodeWithMessage(responseConditionIndex.response));
    }
    return responseConditionIndex.response.data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const getPhaseResolvedtWithData = async (
    authHelper: AuthHelper,   
    deviceId: string,
    channelNumber: number,
    graphDate: string,
    filterChecked?: boolean,
    pdConversion?: string,
    phaseConnectionValue?: string     
) => {
     if(phaseConnectionValue === ""){

    const responsePRData = await ApiRequests.getDataPhaseResolvedGraph(
        {
            deviceId: deviceId,
            channelNumber: channelNumber,
            graphDate: graphDate,
            applyFilter: filterChecked,
            pdConversion: pdConversion
                 

        },
        {
            authHelper,
        }
    );

    if (!responsePRData.ok) {
        console.error(ApiRequests.extractResponseNotOkMessage(responsePRData.response));
        throw new Error(ApiRequests.extractErrorCodeWithMessage(responsePRData.response));
    }
    
    const result: any = {
        deviceId: responsePRData.response.data.deviceId,
        deviceName: responsePRData.response.data.deviceName,
        channelNumber: responsePRData.response.data.channelNumber,
        channelName: responsePRData.response.data.channelName,
        phaseConnection: responsePRData.response.data.phaseConnection,
        chartData: responsePRData.response.data.chartData.map((loc) => ({
            value: loc.value,
            xAxis: loc.xAxis,
            yAxis: loc.yAxis,
        })),
    };
  
    return result;
     }
     

        const responsePRData = await ApiRequests.getDataPhaseResolvedGraph(
            {
                deviceId: deviceId,
                channelNumber: channelNumber,
                graphDate: graphDate,
                applyFilter: filterChecked,
                pdConversion: pdConversion,
                phaseConnection: phaseConnectionValue         
    
            },
            {
                authHelper,
            }
        );
    
        if (!responsePRData.ok) {
            console.error(ApiRequests.extractResponseNotOkMessage(responsePRData.response));
            throw new Error(ApiRequests.extractErrorCodeWithMessage(responsePRData.response));
        }
        
        const result: any = {
            deviceId: responsePRData.response.data.deviceId,
            deviceName: responsePRData.response.data.deviceName,
            channelNumber: responsePRData.response.data.channelNumber,
            channelName: responsePRData.response.data.channelName,
            phaseConnection: responsePRData.response.data.phaseConnection,
            chartData: responsePRData.response.data.chartData.map((loc) => ({
                value: loc.value,
                xAxis: loc.xAxis,
                yAxis: loc.yAxis,
            })),
        };
      
        return result;
};



// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const getReportTableDataList = async (deviceId: string, authHelper: AuthHelper, startMonthAndYear?: string, endMonthAndYear?: string) => {
    //
    const responseReportTableList = await ApiRequests.reportTableData(
        {
            deviceId: deviceId,
            startMonthAndYear: startMonthAndYear,
            endMonthAndYear: endMonthAndYear
        },
        {
            authHelper
        }
    );

    
    if (!responseReportTableList.ok) {
        console.error(ApiRequests.extractResponseNotOkMessage(responseReportTableList.response));
        throw new Error(ApiRequests.extractErrorCodeWithMessage(responseReportTableList.response));
    }
    return responseReportTableList.response.data;
};




export {
    getTemperatureGraphProperties,
    getHumidityGraphProperties,
    getLoadGraphProperities,
    getSensorListResponse,
    getPDIGraphResponse,
    getQmaxApiResponse,
    getPPCApiResponse,   
    getDatetimeListResponse,
    getPhaseResolvedtWithData,
    getRelativeConditionIndexApiResponse,
    getReportTableDataList
    
};
